// extracted by mini-css-extract-plugin
export default {"container":"MoviesTvPage_container__lsI1s","search":"MoviesTvPage_search__rVwNy","loader":"MoviesTvPage_loader__KYikg","shadowPulse":"MoviesTvPage_shadowPulse__ChOMn"};